import {
    tag,
    WeElement,
    render,
    h,
    createElement,
    options,
    define,
    cloneElement,
    getHost,
    rpx,
    defineElement,
    classNames,
    extractClass,
    createRef,
    o,
    elements,
    $,
    extend,
    get,
    set,
    bind,
    unbind
} from 'omi/src/omi'

import apis from './apis'

import htm from 'htm'

const html = htm.bind(h)

import Component from './component'

import { route } from 'omi-router/src'

import uniqueTag from './uniqueTag'

import updateTargets from './updateTargets'

import { throttle, debounce } from 'throttle-debounce'

import './binding'
export {
    tag,
    WeElement,
    Component,
    render,
    h,
    createElement,
    options,
    define,
    cloneElement,
    getHost,
    rpx,
    defineElement,
    classNames,
    extractClass,
    createRef,
    o,
    elements,
    $,
    extend,
    get,
    set,
    bind,
    unbind,
    route,
    apis,
    html,
    uniqueTag,
    updateTargets, throttle, debounce
}

options.root.omii = { ...options.root.omi, Component, route, apis, html, uniqueTag, updateTargets, throttle, debounce }